import { WidgetPropertyType, createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'Post Header',
  props: {
    isRatingsEnabled: {
      type: WidgetPropertyType.BOOLEAN,
      description: 'Indicates if the ratings widget is enabled',
      defaultValue: false,
    },
    isCommentsPluginInstalled: {
      type: WidgetPropertyType.BOOLEAN,
      description: 'Indicates if the comments plugin is installed',
      defaultValue: false,
    },
  },
  methods: {
    counters: {
      description: 'Returns the counters widget',
    },
  },
  events: {},
});
